import ArticleCallToAction from '@/cmsComponents/ArticleCallToAction';
import { MarkdownContent } from '@/cmsComponents/MarkdownContent';
import { IArticleCta } from '@/types/cms';
import React, { useState } from 'react';

type ArticleContentWithCtaProps = {
  content: string;
  articleCta?: IArticleCta;
};

const ArticleContentWithCta = ({ content, articleCta }: ArticleContentWithCtaProps) => {
  // splitting on newline character had a couple of "" entries in the splitContent array so filter them out too
  const splitContent = content.split('\n').filter(paragraph => paragraph.trim());

  // Get the exact mid point as the inital value
  const [ctaIndex, setCtaIndex] = useState<number>(
    Math.max(Math.floor(splitContent.length / 2), 1),
  );
  const hasArticleCta = !!articleCta;

  const isCtaInList = (firstChar: string) => {
    // If the first character is a number or a -, assume it is a list and move the CTA down one
    if (!!Number(firstChar) || firstChar === '-') {
      setCtaIndex(prevIndex => prevIndex + 1);
    }
  };

  const blocks: React.ReactNode[] = [];

  for (let i = 0; i < splitContent.length; i++) {
    if (i === ctaIndex && hasArticleCta) {
      isCtaInList(splitContent[i].charAt(0));
      blocks.push(<ArticleCallToAction {...articleCta} />);
    }
    blocks.push(<MarkdownContent source={splitContent[i]} />);
  }
  if (blocks.length === 1 && hasArticleCta) {
    blocks.push(<ArticleCallToAction {...articleCta} />);
  }

  return <>{blocks}</>;
};

export default ArticleContentWithCta;
